<section class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">Mes Logements
      <button class="btn btn-blue btn-lg btn-circle float-end" routerLink="creer">
        <fa-icon [icon]="faPlus"></fa-icon>
      </button>
    </h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    @if (logement$ | async; as logements) {
      @if (logements.length) {
        @if (logementCourant$ | async; as logementCourant) {
          <div class="container-fluid">
            @for (logement of logements; track logement) {
              <app-row-item
                (rowClick)="setLogementCourant(logement)"
                [active]="logementCourant.id == logement.id"
                [title]="logement.nom"
                [subtitle]="getLogementSubtitle(logement)"
                [secondSubtitle]="getLogementSecondSubtitle(logement)">
                <ng-container prepend>
                  <fa-icon [icon]="logementCourant.id == logement.id ? faCheckCircle : faCircle" size="lg"
                  class="check me-3"></fa-icon>
                </ng-container>
                <ng-container actions>
                  <button ngbDropdownItem (click)="setLogementCourant(logement)">Sélectionner</button>
                  @if (logement.userPermissions.updatable) {
                    <a ngbDropdownItem [routerLink]="'modifier/' + logement.id">Modifier</a>
                  }
                  @if (logement.userPermissions.deletable) {
                    <app-delete-confirm (deleted)="delete(logement)"
                      [message]="'Confirmez-vous la suppression de ce logement ?'">
                      <button ngbDropdownItem>Supprimer</button>
                    </app-delete-confirm>
                  }
                  @if (userService.canVoirMesLocataires(logement)) {
                    <button ngbDropdownItem (click)="goToMesLocataires(logement)">Mes locataires</button>
                  }
                  @if (logement.userPermissions.updatable) {
                    <a ngbDropdownItem [routerLink]="'ajout-proprietaire/' + logement.id">Gérer les copropriétaires</a>
                  }
                  @if (userService.canVendreLogement(logement)) {
                    <button ngbDropdownItem (click)="changementProprietaire(logement)">Je vends mon logement</button>
                  }
                </ng-container>
              </app-row-item>
            }
          </div>
        }
      } @else {
        <div class="alert alert-info">Vous n'avez actuellement aucun logement.</div>
        <div class="d-flex justify-content-center">
          <a class="btn btn-blue btn-lg" routerLink="creer">
            <fa-icon [icon]="faPlus"></fa-icon>&nbsp;Je crée mon premier logement
          </a>
        </div>
      }
    }
  </div>
</section>
